/**
 * Bundle-local state. Each bundle that loads `@servicetitan/datadog-rum` gets
 * its own copy of this module; nothing here lives on `globalThis`. The bundle
 * whose `init` call wins the SDK init race sets `isSdkInitializer` here, and
 * only its own bundle's `setUser` reads `true` from it.
 */
export const bundleState = {
    isSdkInitializer: false,
};
